import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UBaseInfraComponent } from '../u-base-infra.component';

export type UBadgeStyle = 'primary';
export type UBadgeSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'u-badge',
  templateUrl: './u-badge.component.html',
  styleUrls: ['./u-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class UBadgeComponent extends UBaseInfraComponent {
  text = input<string>('');

  getIconRef() {
    return null;
  }
}
